import { render, staticRenderFns } from "./Footer-v2.vue?vue&type=template&id=53e70fa2&scoped=true&"
import script from "./Footer-v2.vue?vue&type=script&lang=js&"
export * from "./Footer-v2.vue?vue&type=script&lang=js&"
import style0 from "./Footer-v2.vue?vue&type=style&index=0&id=53e70fa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e70fa2",
  null
  
)

export default component.exports